<button mat-button class="open-select-button" (click)="open()" aria-haspopup="dialog">
    <span class="button-content-wrapper">
      <span class="placeholder">{{ "title.clients" | translate | async }}</span>
      <vue-number-indicator
        [number]="selectedClients"
      ></vue-number-indicator>
      <img class="select-carrot" src="/assets/icons/icon-open-select.svg" alt="" />
    </span>
  </button>
  